angular
	.module 'App.Repository'

.factory 'JournalEntry', ['BaseRepository', (BaseRepository) ->
	class JournalEntry extends BaseRepository
		@resource = '/journal_entries'
		@isRestricted = true

	return new JournalEntry
]
